import { createContext } from 'react'

export const CheckoutIdContext = createContext({});